import React from "react";
import PropTypes from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import "./AdCard.m.css";

const AdCard = ({ card, isDesktop = false }) => {
  const { ["story-elements"]: storyElements = [] } = card || {};

  const imageElement = storyElements.find(el => el.type === "image");
  if (!imageElement) return null;

  const {
    ["image-s3-key"]: imageUrl,
    hyperlink,
    ["image-metadata"]: imageMetadata = {},
  } = imageElement;

  if (!imageUrl) return null;

  const image = (
    <div styleName="ad-image">
      <ResponsiveImage
        slug={imageUrl}
        metadata={imageMetadata}
        aspectRatio={null}
        defaultWidth={480}
        widths={[240, 300, 480]}
        imgParams={{ auto: ["format", "compress"] }}
        alt="Advertisement"
      />
    </div>
  );

  const content = hyperlink ? (
    <a
      href={hyperlink}
      styleName="ad-link"
      target="_blank"
      rel="noopener"
    >
      {image}
    </a>
  ) : (
    image
  );

  return isDesktop ? (
    <div styleName="ad-unit-desktop">{content}</div>
  ) : (
    <div styleName="ad-unit-container">
      <div styleName="ad-unit">
        <div styleName="ad-image-wrapper">{content}</div>
      </div>
    </div>
  );
};

AdCard.propTypes = {
  card: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool,
};

export default AdCard;
